"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class InvalidParametersError extends client_library_1.ExtendableError {
    constructor() {
        super(`Invalid parameters`);
    }
}
exports.default = InvalidParametersError;
//# sourceMappingURL=InvalidParametersError.js.map